import { UseMutationOptions } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';
import { audienceQueryKeys } from '/component/Support/BeetlesLookup/constants';
import { SupportContentType, IBeetleId } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export const useDeleteNote = (
  type: SupportContentType,
  options?: UseMutationOptions<
    CommonSuccess,
    GenericFailure | Error,
    { id: IBeetleId; noteId: string; env: Environment }
  >
) => {
  const service = methods(type);
  return useEitherMutation(({ id, noteId, env }) => service.deleteNote(id, noteId, env), {
    removeQueriesKeys: audienceQueryKeys,
    ...options,
  });
};
